import { render, staticRenderFns } from "./addCompanyForm.vue?vue&type=template&id=7fd1b5d5"
import script from "./addCompanyForm.vue?vue&type=script&lang=js"
export * from "./addCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports